import styled from "styled-components";

const Container = styled.div`
  background-color: #fff;
  display: block;
  height: 100vh;
`;

const Page = styled.div`
  display: flex;
  flex-direction: column;
  /* width: 100%; */
  background-color: #fff;
  justify-content: center;
  align-items: center;
  padding: 40px;
  /* height: ${props => (props.fullScreen ? "100vh" : "100%")}; */

  .plan-cards__container {
    height: 100%;
  }
/* 
  @media (min-width: 1440px) {
    height: 100vh;
  } */

  @media (max-width: 1250px) {
    .plan-cards__container,
    .UpgradePage__footer {
      padding: 0 40px;
    }
  }

  @media (max-width: 980px) {
    .plan-cards__container,
    .UpgradePage__footer {
      width: 510px;
    }
  }

  @media (max-width: 454px) {
    .plan-cards__container {
      width: 100%;
      padding: 0 8px;
    }
  }
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 900;
  color: #222939;
  margin-top: 40x;
`;

const Subtitle = styled.div`
  font-size: 18px;
  color: #6f7582;
  margin-top: 8px;
  margin-bottom: 32px;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 1024px;

  @media (max-width: 454px) {
    width: auto;
    justify-content: center;
  }
`;

const CloseIcon = styled.img`
  position: absolute;
  top: 30px;
  right: 30px;
  opacity: 0.7;
  cursor: pointer;

  @media (max-width: 530px) {
    top: 15px;
    right: 15px;
    .plan-cards__container {
      top: 30px;
      right: 30px;
    }
  }
`;

export { Container, Title, Subtitle, Footer, CloseIcon, Page };



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/UpgradeStyle.js